import './OrderCard.css';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import lab_test_order_form from '../../files/SGI-Service-Manifest v2.2.xlsx';
import kit_order_form from '../../files/SGI-Kit-Manifest.xlsx';
import sample_handling_sheet from '../../files/Sample Handling Sheet V7.pdf';

const OrderCard = () => {
  return (
    <div className='order-cards'>
      <div className='order-stage-item'>
        <h5 className='order-stage-label'>Stage 1</h5>
        <div className='order-icon-wrap'>
          <ArticleOutlinedIcon className='order-icon' />
        </div>
        <h4 className='order-arrow-title'>Download manifest</h4>
        <div className='order-action'>
          <a className='order-link' href={lab_test_order_form}>
            Lab Manifest <FileDownloadOutlinedIcon />
          </a>
          <a className='order-link' href={kit_order_form}>
            Kit Manifest <FileDownloadOutlinedIcon />
          </a>
        </div>
      </div>

      <div className='order-connector' />

      <div className='order-stage-item'>
        <h5 className='order-stage-label'>Stage 2</h5>
        <div className='order-icon-wrap'>
          <EmailOutlinedIcon className='order-icon' />
        </div>
        <h4 className='order-arrow-title'>Send manifest</h4>
        <div className='order-action'>
          <p className='send-to-email'>Send to email:</p>
          <a className='order-link' href='mailto: orders@sciscogenetics.com'>
            orders@sciscogenetics.com
          </a>
        </div>
      </div>

      <div className='order-connector' />

      <div className='order-stage-item'>
        <h5 className='order-stage-label'>Stage 3</h5>
        <div className='order-icon-wrap'>
          <AssignmentTurnedInOutlinedIcon className='order-icon' />
        </div>
        <h4 className='order-arrow-title'>Get a quote</h4>
        <div className='order-action'>
          <p className='order-arrow-desc' style={{ color: 'var(--orange)' }}>Expect quote within 24 hours</p>
        </div>
      </div>

      <div className='order-connector' />

      <div className='order-stage-item'>
        <h5 className='order-stage-label'>Stage 4</h5>
        <div className='order-icon-wrap'>
          <Inventory2OutlinedIcon className='order-icon' />
        </div>
        <h4 className='order-arrow-title'>Send samples</h4>
        <div className='order-action'>
          <a
            className='order-link'
            href={sample_handling_sheet}
            target='_blank'
            rel='noreferrer'
          >
            Sample Handling Sheet <FileDownloadOutlinedIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
